// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../components/Main.vue'
import SignUp from '../components/SignUp.vue'
// import ManageAccount from '../components/ManageAccount.vue'
import ManageComponent from '../components/ManageComponent.vue'
import LiveBroker from '../components/LiveBroker.vue'
// import LiveBrokersSelector from '../components/LiveBrokersSelector.vue'
import EmailVerification from '../components/EmailVerification.vue'
import LiveBrokersSelectorV2 from '../components/LiveBrokersSelectorV2.vue'
// import About from '../views/About.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Main', redirect: '/login' },
  { path: '/login', name: 'Main', component: Main },
  { path: '/register', name: 'SignUp', component: SignUp },
  // { path: '/manage-account', name: 'Manage Account', component: ManageAccount },
  { path: '/manage', name: 'Accounts', component: ManageComponent },
  { path: '/email-verification', name: 'Email Verification', component: EmailVerification },
  { path: '/demo-pages/us-account', name: 'Live Brokers', component: LiveBrokersSelectorV2 },
  { path: '/widgets/live-brokers', name: 'LiveBroker', component: LiveBroker },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
